<template>
  <v-container fluid>
    <!-- <v-data-iterator
      :items="items"
      :itemsPerPage.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sortBy="sortBy.toLowerCase()"
      :sortDesc="sortDesc"
      hideDefaultFooter
    >
      <template v-slot:header>
        <v-toolbar dark color="blue darken-3" class="mb-1">
          <v-text-field
            v-model="search"
            clearable
            flat
            soloInverted
            hideDetails
            prependInnerIcon="mdi-magnify"
            label="Search"
          ></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select
              v-model="sortBy"
              flat
              soloInverted
              hideDetails
              :items="keys"
              prependInnerIcon="mdi-magnify"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="sortDesc" mandatory>
              <v-btn large depressed color="blue" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn large depressed color="blue" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.name"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <div>placeholder</div>
            <!-- <MarketItem /> -->
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offsetY>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" class="ml-2" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator> -->
  </v-container>
</template>

<script>
// import MarketItem from '~/components/MarketItem';
export default {
  name: "BaseItemIterator",
  // components: {
  //   MarketItem,
  // },
  // data() {
  //   return {
  //     filter: {},
  //     items: [
  //       {
  //         catergory: 'electronics and peripherals',
  //         price: 800,
  //         type: 'Physical',
  //       },
  //       {
  //         catergory: 'electronics and peripherals',
  //         price: 800,
  //         type: 'Physical',
  //       },
  //       {
  //         catergory: 'electronics and peripherals',
  //         price: 800,
  //         type: 'Physical',
  //       },
  //       {
  //         catergory: 'electronics and peripherals',
  //         price: 800,
  //         type: 'Physical',
  //       },
  //     ],
  //     itemsPerPage: 4,
  //     itemsPerPageArray: [4, 8, 12],
  //     keys: ['Type', 'Category', 'Price'],
  //     page: 1,
  //     search: '',
  //     sortBy: 'name',
  //     sortDesc: false,
  //   };
  // },
  // computed: {
  //   filteredKeys() {
  //     return this.keys.filter((key) => key !== `Name`);
  //   },
  //   numberOfPages() {
  //     return Math.ceil(this.items.length / this.itemsPerPage);
  //   },
  // },
  // methods: {
  //   formerPage() {
  //     if (this.page - 1 >= 1) this.page -= 1;
  //   },
  //   nextPage() {
  //     if (this.page + 1 <= this.numberOfPages) this.page += 1;
  //   },
  //   updateItemsPerPage(number) {
  //     this.itemsPerPage = number;
  //   },
  // },
};
</script>
